import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Timezone } from '../models/timeZone';
import { Language } from '../models/language';
import { Observable } from 'rxjs';
import { SerivceType } from '../models/serviceType';
import { LocationType } from '../models/locationType';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { PermissionGroup } from '../models/permissionGroup';
import { NotificationGroup } from '../models/NotificationGroup';
import { HomeLocation } from '../models/homeLocation';
import { Country } from '../models/country';
import { KeyValue } from '../models/keyValue';
import { ACClientConfiguration } from 'src/app/shared/models/acClientConfiguration';
import IConferencingProviderConfiguration from '../models/conferencingProviderConfiguration';


@Injectable({
  providedIn: 'root'
})
export class MasterLookupService {
  lookupsRequestUri = '';
  appConfig?: AppConfigurations;

  constructor(private httpClient: HttpClient, private appInitService: AppInitService) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations){
    this.appConfig = appConfig;
    this.lookupsRequestUri =
    `${this.appConfig.adminApi.baseApiUrl}${this.appConfig.adminApi.lookupsController}`;
  }

  getCurrentConferencingProvider(): Observable<string> {
    const confProviderLookupUri = `${this.lookupsRequestUri}/currentConferencingProvider`
    return this.httpClient.get<string>(confProviderLookupUri);
  }
  getVerificationToken(userId:number): Observable<boolean> {
    const confProviderLookupUri = `${this.lookupsRequestUri}/${userId}/conferencingRefreshTokenVerify`
    return this.httpClient.get<boolean>(confProviderLookupUri);
  }
  
  getCurrentConferencingProviderDetails(): Observable<IConferencingProviderConfiguration> {
    const url = `${this.lookupsRequestUri}/conferencingProviderDetails`;
    return this.httpClient.get<IConferencingProviderConfiguration>(url);
  }
  getConferencingProviderAuthenticationStatus(userId: string): Observable<string> {
    const url = `${this.lookupsRequestUri}/${userId}/conferencingproviderauthenticationstatus`;
    return this.httpClient.get<string>(url);
  }
  getTimeZones(): Observable<Timezone[]>  {
    const timeZoneApiUri = `${this.lookupsRequestUri}/${'timezones'}`;
    return this.httpClient.get<Timezone[]>(timeZoneApiUri);
  }

  getLanguages(): Observable<Language[]>  {
    const languageApiUri = `${this.lookupsRequestUri}/${'languages'}`;
    return this.httpClient.get<Language[]>(languageApiUri);
  }

  getUserIdUserNameLookUp() : Observable<any[]>
  {
    const url = `${this.lookupsRequestUri}/userIdNamelookup`;
    return this.httpClient.get<any>(url);
  }

  getServiceTypes() : Observable<SerivceType[]>
  {
    const url =  `${this.lookupsRequestUri}/${'serviceTypes'}`;
    return this.httpClient.get<SerivceType[]>(url);
  }

  getLocationTypes(): Observable<LocationType[]>
  {
    const url = `${this.lookupsRequestUri}/locationTypes`;
    return this.httpClient.get<LocationType[]>(url);
  }

  getHomeLocations(): Observable<HomeLocation[]>
  {
    const url = `${this.lookupsRequestUri}/homeLocations`;
    return this.httpClient.get<HomeLocation[]>(url);
  }

  getHomeLocationsbyType(locationTypeId:number): Observable<HomeLocation[]>
  {
    const url = `${this.lookupsRequestUri}/homelocations/${locationTypeId}`;
    return this.httpClient.get<HomeLocation[]>(url);
  }

  getMeetingPreferences() : Observable<string>
  {
    const url =`${this.lookupsRequestUri}/meetingPreferences`;
    return this.httpClient.get<string>(url);
  }

  getPermissiongGroups(includeAll: boolean = false): Observable<PermissionGroup[]> {
    const url = includeAll
      ? `${this.lookupsRequestUri}/permissionGroups?includeAll=true`
      : `${this.lookupsRequestUri}/permissionGroups`;
    return this.httpClient.get<PermissionGroup[]>(url);
  }

  getPermissiongGroupsForUser(userId: number): Observable<PermissionGroup[]> {
    const url = `${this.lookupsRequestUri}/permissionGroups/${userId}`;
    return this.httpClient.get<PermissionGroup[]>(url);
  }

  getNotificationGroups(): Observable<NotificationGroup[]> {
    const url = `${this.lookupsRequestUri}/notificationGroups`;
    return this.httpClient.get<NotificationGroup[]>(url);
  }

  getAllCountries(): Observable<Country[]> {
    const url = `${this.lookupsRequestUri}/countries`;
    return this.httpClient.get<Country[]>(url);
  }

  getAllConcurrencyModes(): Observable<KeyValue<number, string>[]> {
    const url = `${this.lookupsRequestUri}/concurrencymodes`;
    return this.httpClient.get<KeyValue<number, string>[]>(url);
  }

  getAllFloatPriorityModes(): Observable<KeyValue<number, string>[]> {
    const url = `${this.lookupsRequestUri}/floatprioritymodes`;
    return this.httpClient.get<KeyValue<number, string>[]>(url);
  }

  getACClientConfiguration(): Observable<ACClientConfiguration> {
    const url = `${this.lookupsRequestUri}/acClientConfig`;
    return this.httpClient.get<ACClientConfiguration>(url);
  }

}
